module.exports = __webpack_public_path__ + "r-v3/img/ml_10_00.b793494d.jpg";